// The native WKWebView scrolls the page when the keyboard opens instead of
// shrinking the layout viewport, so the fixed chat containers keep their full
// height and their header scrolls off-screen. Expose the visual viewport — the
// only thing that reflects the keyboard there — for _chat.scss/_chat_overlay.scss
// to size against. offsetTop cancels out that scroll.
const visualViewport = window.visualViewport;

if (visualViewport) {
  const root = document.documentElement;
  let pendingFrame = null;

  const apply = () => {
    pendingFrame = null;
    root.style.setProperty("--mwai-vv-height", `${visualViewport.height}px`);
    root.style.setProperty("--mwai-vv-top", `${visualViewport.offsetTop}px`);
  };

  // both fire rapidly while the keyboard animates
  const schedule = () => {
    if (pendingFrame === null) pendingFrame = requestAnimationFrame(apply);
  };

  visualViewport.addEventListener("resize", schedule);
  visualViewport.addEventListener("scroll", schedule);
  apply();
}
